import { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import axios from "axios";
import { FaSpinner } from "react-icons/fa";
import { hideModal, showModal } from "../../utils/modalUtility";
import Pagination from "../common/pagination";

function Ammenities() {
  const [ammenities, setAmmenities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const axiosAPI = useAxios();

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [formData, setFormData] = useState({
    name: "",
  });

  const removeFormData = () => {
    setFormData({
      name: "",
    });
  };

  // Get All Ammenities
  const getMedia = async () => {
    try {
      const response = await axiosAPI.get(`/api/ammenities?page=${page}`);
      //   console.log(response.data.data);
      setAmmenities(response.data.data);
      setTotalPages(response?.data?.totalPages);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  //   Handle Input Changes
  const handleChange = (e) => {
    // console.log(e.target.id, e.target.value);
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // Handle Submit (Add or Edit)
  const handleSubmit = async (e) => {
    e.preventDefault();

    // ======================
    // COMMON VALIDATION
    // ======================
    if (!formData.name) {
      return window.notifyMessage(
        "Validation Error",
        "Please enter a name for the amenity.",
        "warning",
      );
    }

    setIsLoading(true);

    const payload = {
      name: formData.name,
    };

    try {
      let response;
      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/ammenities/${currentUserId}`,
          payload,
        );
        window.notifyMessage(
          "Success",
          "Amenity updated successfully",
          "success",
        );
      } else {
        response = await axiosAPI.post("/api/ammenities", payload);

        window.notifyMessage(
          "Success",
          "Amenity added successfully",
          "success",
        );
      }
      hideModal("newGalleryModal");
      getMedia();
      removeFormData();
      setIsEditMode(false);

      // window.location.reload(); // Reload page to reflect changes in the Property list
      closeModal();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Edit Modal Open
  const openEditModal = (id) => {
    setCurrentUserId(id);
    // console.log(id);

    // Find the notification with this ID and populate the form
    const selectedMedia = ammenities.find((ammenity) => ammenity.id === id);

    if (!selectedMedia) return;

    // console.log("Open edit modal", selectedMedia);
    if (selectedMedia) {
      setFormData({
        name: selectedMedia.name,
      });
    }

    setIsEditMode(true);
    showModal("newGalleryModal");
  };

  // console.log(enquiries)

  const handleDelete = async (id) => {
    console.log(id);
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/ammenities/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      getMedia();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger",
      );
    }
  };

  // Close Modal
  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  const openAddModal = () => {
    showModal("newGalleryModal");
  };

  useEffect(() => {
    getMedia();
  }, [page]);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openAddModal()}
            >
              Add Ammenity
            </button>
          </div>
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id="newGalleryModal"
          tabIndex="-1"
          aria-labelledby="newGalleryModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newGalleryModalLabel">
                  {isEditMode ? "Edit Ammenity" : "Add Ammenity"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>

              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Property Name (Input Field) */}
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Enter ammenity name"
                      value={formData.name}
                      onChange={handleChange}
                      // required
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                    disabled={isLoading} // Disable button while isLoading
                  >
                    {isLoading ? (
                      <FaSpinner className="spinner" spin /> // Loader icon from react-icons
                    ) : isEditMode ? (
                      "Update Ammenity"
                    ) : (
                      "Add Ammenity"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Notification Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                {/* Left Section - User Details */}
                <div className="d-flex align-items-center">
                  <h4 className="card-title mb-0">
                    All Ammenities ({ammenities?.length} )
                  </h4>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        // Show a loading state when data is being fetched
                        <tr>
                          <td colSpan="3" className="text-center">
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : ammenities?.length == 0 ? (
                        // Show a "No Data Found" message when no data is available
                        <tr>
                          <td colSpan="3" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        // Render the list of leads if data is available
                        ammenities?.map((ammenity, index) => {
                          return (
                            <tr key={ammenity.id}>
                              <td>{index + 1}</td>
                              <td>{ammenity.name}</td>
                              <td>
                                <button
                                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                  onClick={() => openEditModal(ammenity.id)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                  onClick={() => handleDelete(ammenity.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ammenities;
